// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownInput__root___VoOoh","input":"DropdownInput__input___2oSin","required":"DropdownInput__required___20rg0","placeholder":"DropdownInput__placeholder___1efP2"};